// Rotta di default a cui il proxy reindirizza quando manca lo step nell'URL.
// Forma: `<path>/<segmento>` -> qui "step/1" (primo step).
export const DEFAULT_ROUTE = "/welcome";
export const DEFAULT_LOCALE: string = "it";
export const HABACUS_STATIC_URL: string =
    process.env.APP_ENV === "staging"
        ? "https://static.test.habacus.com"
        : "https://static.habacus.com";

export const API_V1_BASE = "/api/v1";

export const ROUTE_LOGIN = "/login";
export const ROUTE_LOGIN_FAILED = "/login/failed";
export const ROUTE_LOGIN_SUCCESS = "/login/success";

export const ROUTE_LOGIN_FROM_SPID = (basePath: string, locale: string) =>
    `${basePath}/${locale}${ROUTE_LOGIN}`;
export const ROUTE_LOGIN_FAILED_FROM_SPID = (
    basePath: string,
    locale: string,
) => `${basePath}/${locale}${ROUTE_LOGIN_FAILED}`;
export const ROUTE_LOGIN_SUCCESS_FROM_SPID = (
    basePath: string,
    locale: string,
) => `${basePath}/${locale}${ROUTE_LOGIN_SUCCESS}`;

export const LOV_ENDPOINT = `${API_V1_BASE}/lov`;
export const PATH_ENDPOINT = `${API_V1_BASE}/path`;
export const ANSWER_ENDPOINT = `${API_V1_BASE}/answer`;
export const SPID_ENDPOINT = `${API_V1_BASE}/spid`;
export const VERIFICATION_ENDPOINT = `${API_V1_BASE}/verification`;

export const LOV_ENDPOINT_BY_UUID = (listOfValuesUuid: string) =>
    `${LOV_ENDPOINT}/${listOfValuesUuid}`;
export const PATH_ENDPOINT_BY_UUID = (verificationUuid: string) =>
    `${PATH_ENDPOINT}/${verificationUuid}`;
export const SPID_ENDPOINT_BY_UUID = (verificationUuid: string) =>
    `${SPID_ENDPOINT}/${verificationUuid}`;
export const VERIFICATION_ENDPOINT_BY_UUID = (verificationUuid: string) =>
    `${VERIFICATION_ENDPOINT}/${verificationUuid}`;
